"use strict";
/**
 * imports
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpConnection = void 0;
// external
const axios_1 = require("axios");
const inversify_1 = require("inversify");
const http_status_codes_1 = require("http-status-codes");
// local
const errorTypes_1 = require("../../helpers/errorTypes");
/**
 * http connection class
 */
let HttpConnection = class HttpConnection {
    constructor() {
        // url to make request to
        this.url = null;
        // token for authentication
        this.bearerToken = null;
    }
    async getRawRequestConfig(args) {
        const requestConfig = this.getRequestConfigForArgs(args);
        return requestConfig;
    }
    /**
     * make http request
     *
     * @param {INetworkRequestArgs} args
     * @returns {Promise<any>}
     */
    async makeRequest(args) {
        const requestConfig = this.getRequestConfigForArgs(args);
        try {
            // make the request
            const res = await axios_1.default.request(requestConfig);
            // return response
            return res.data;
        }
        catch (e) {
            if (args.handleOwnError) {
                throw e;
            }
            if (e.response) {
                // try and throw appropriate error
                if (e.response.status === http_status_codes_1.StatusCodes.NOT_FOUND) {
                    // not found error
                    if (args.allow404) {
                        return e.response.data;
                    }
                    throw new errorTypes_1.NotFoundError((e.response.data.error || `Not found `) + args.url);
                }
                // forbidden error
                if (e.response.status === http_status_codes_1.StatusCodes.FORBIDDEN) {
                    if (args.allow403) {
                        return e.response.data;
                    }
                    throw new errorTypes_1.ForbiddenError((e.response.data.error || `Forbidden `) + args.url);
                }
                // unauthorized error
                if (e.response.status === http_status_codes_1.StatusCodes.UNAUTHORIZED) {
                    throw new errorTypes_1.UnauthorizedError((e.response.data.error || `Unauthorized `) + args.url);
                }
            }
            // services threw an unexpected error
            console.error("services request error:", e, args);
            throw new Error(e.response.data.error);
        }
    }
    getRequestConfigForArgs(args) {
        // cannot make a request without a URL to hit
        if (!this.url) {
            throw new Error("Url not set, cannot make request");
        }
        // content will always be JSON
        const headers = {
            "Content-Type": "application/json"
        };
        // add authentication
        const bearerToken = args.overrideBearerToken || this.bearerToken;
        if (bearerToken) {
            headers.Authorization = `Bearer ${bearerToken}`;
        }
        const axiosRequestConfig = {
            url: this.url + args.url,
            method: args.method,
            params: args.params,
            data: args.data,
            withCredentials: true,
            headers
        };
        return axiosRequestConfig;
    }
};
HttpConnection = __decorate([
    (0, inversify_1.injectable)()
], HttpConnection);
exports.HttpConnection = HttpConnection;
//# sourceMappingURL=HttpConnection.js.map